import { Component, OnDestroy } from "@angular/core";
import { NbDialogRef, NbGlobalPhysicalPosition, NbToastrService } from "@nebular/theme";
import { AuthClient, CustomerClient, CustomerVm } from "../../../../System-api";
import { Router } from "@angular/router";
import { NbAuthService, NbTokenService } from "@nebular/auth";

@Component({
  selector: "change-account-modal",
  templateUrl: "./change-account-modal.component.html",
})
export class ChangeAccountModalComponent implements OnDestroy {
  companyId: string;
  processRequest: string = "request";
  question: any;
  customer: CustomerVm;
  flowId: number;
  waitTime: number = 30;
  countdownInterval: any;
  alwaysImpersonateUser: boolean;

  constructor(
    protected ref: NbDialogRef<ChangeAccountModalComponent>,
    private authClient: AuthClient,
    private authService: NbAuthService,
    private toastrService: NbToastrService,
    private router: Router,
    private tokenService: NbTokenService,
    private customerClient: CustomerClient
  ) {}

  ngOnInit(): void {
    this.customer = new CustomerVm();
    this.customerClient.getCustomerByCompanyId(this.companyId).subscribe((rs) => {
      if (rs) {
        this.customer = rs;
        if (this.alwaysImpersonateUser) {
          this.handleChangeUser();
          return;
        }
        this.question = `Current flow is owned by <b>${this.customer.companyVm.name}</b>. <br/><br/>
            Login as <b>${this.customer.fullName}</b> to continue? <br/><br/>
            Navigate back to flow management in ${this.waitTime} seconds.`;
        this.startCountdownRequest();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  dismiss() {
    this.router.navigate([`/portal/studio/callflows`]);
    this.alwaysImpersonateUser = false;
    window.localStorage.setItem("always_impersonate_user", this.alwaysImpersonateUser.toString());
    this.ref.close();
  }

  handleChangeUser() {
    this.authClient.impersonate(this.customer.email).subscribe({
      next: (rs) => {
        if (rs) {
          localStorage.setItem("auth_app_token", rs);
          this.authService.refreshToken("email", rs);
          this.authService.getToken().subscribe((token) => this.tokenService.set(token));
          this.showToast(true, `Login as "${this.customer.fullName}" successfully`, ``);
          this.router.navigateByUrl(`/callflow-design/${this.flowId}`);
          this.ref.close(true);
        } else {
          this.showToast(false, "", `Login as "${this.customer.fullName}" unsuccessfully`);
        }
      },
      error: (error) => {
        this.showToast(false, "", `Login as "${this.customer.fullName}" unsuccessfully`);
        this.alwaysImpersonateUser = false;
        window.localStorage.setItem("always_impersonate_user", this.alwaysImpersonateUser.toString());
        this.ref.close();
      },
    });
  }
  showToast(result, successText, failText) {
    if (result) {
      this.toastrService.show(successText, `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "success",
      });
    } else {
      this.toastrService.show(failText, `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    }
  }

  startCountdownRequest() {
    this.countdownInterval = setInterval(() => {
      this.waitTime--;
      this.question = `Current flow is owned by <b>${this.customer.companyVm.name}</b>. <br/><br/>
      Login as <b>${this.customer.fullName}</b> to continue? <br/><br/>
      Navigate back to flow management in ${this.waitTime} seconds.`;

      if (this.waitTime <= 0) {
        clearInterval(this.countdownInterval);
        this.dismiss();
      }
    }, 1000);
  }

  toggleAutoLogin(alwaysImpersonateUser: boolean) {
    this.alwaysImpersonateUser = alwaysImpersonateUser;
    window.localStorage.setItem("always_impersonate_user", this.alwaysImpersonateUser.toString());
  }
}
